export const toLocalDateString = (dateObj) => {
  if (!dateObj) return null;
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const isDateEditable = (date, isAdmin, currentUser) => {
  if (!date) return false;
  if (isAdmin) return true;

  // Get current time in user's specified timezone
  const tz = currentUser?.timezone || 'Asia/Kolkata';
  const now = new Date();
  
  // Format current date to user's timezone date string
  const localTodayStr = now.toLocaleDateString('en-CA', { timeZone: tz }); // yyyy-mm-dd
  const todayInTz = new Date(localTodayStr);
  todayInTz.setHours(0, 0, 0, 0);

  // Parse the check date (ensure it's treated as local midnight)
  const checkDate = new Date(date);
  checkDate.setHours(0, 0, 0, 0);

  // Get Monday of current calendar week in that timezone
  const currentMonday = new Date(todayInTz);
  const dayOfWeek = currentMonday.getDay(); // 0 is Sunday
  const diff = currentMonday.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  currentMonday.setDate(diff);

  // Policy: Locked if in past week
  if (checkDate < currentMonday) return false;
  
  // Policy: Locked if in future
  if (checkDate > todayInTz) return false;

  return true;
};

export const getDaysInMonth = (currentDate) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [];
  for (let i = 0; i < firstDay; i += 1) days.push(null);
  for (let i = 1; i <= daysInMonth; i += 1) days.push(new Date(year, month, i));
  return days;
};
